module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Bold.15fc08a9.ttf";